module.exports = __webpack_public_path__ + "OpenSans-Regular.629a55a7e793da068dc5.ttf";


//////////////////
// WEBPACK FOOTER
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/assets/ra/fonts/OpenSans-Regular.ttf
// module id = ../../../../../assets/ra/fonts/OpenSans-Regular.ttf
// module chunks = main